export const site = {
  name: 'Courtney.care',
  legalName: "Courtney's Creative Care",
  firstName: 'Courtney',
  role: 'Childcare Professional',
  location: 'Atlanta, GA',
  email: 'me@Courtney.care',
} as const;
